import { Typography, Button } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconCheck, IconChevronDown } from "@tabler/icons-react";

interface StepCardProps {
  title: string;
  status: "completed" | "upcoming";
  onEdit?: () => void;
}

const StepCard = ({ title, status, onEdit }: StepCardProps) => {
  return (
    <div className="al-border al-rounded-lg">
      <Stack direction="row" justify="between" align="center" className="al-w-full al-p-4">
        <Stack direction="row" gap="md" align="center" flex="1">
          <Typography
            variant="body"
            weight="medium"
          >
            {title}
          </Typography>
          {status === "completed" && (
            <Stack
              direction="row"
              align="center"
              justify="center"
              className="al-w-6 al-h-6 al-rounded-full al-bg-green-500"
            >
              <IconCheck className="al-text-white" size={14} />
            </Stack>
          )}
        </Stack>
        {status === "completed" && onEdit && (
          <Button variant="ghost" size="sm" className="al-text-blue-600" onClick={onEdit}>
            Edit
          </Button>
        )}
        {status === "upcoming" && (
          <Button disabled={true} variant="ghost" size="sm" className="al-text-blue-600">
            <IconChevronDown />
          </Button>
        )}
      </Stack>
    </div>
  );
};

export default StepCard;
